<template>
  <v-dialog
    :value="value"
    max-width="600px"
    @input="$emit('input', $event)"
    @keydown.esc="cancel"
  >
    <v-card>
      <v-card-title>Clone Ingredient</v-card-title>
      <v-card-text>
        <p class="caption mb-4">
          The copy keeps the nutrients, tags, price and cooking method of
          <strong>{{ sourceName }}</strong>, but needs its own name and description.
        </p>
        <v-text-field
          v-model="editName"
          label="Ingredient name"
          hint="Shown on the ingredients list and, up to the first comma, on the customer label"
          persistent-hint
          autofocus
          class="mb-6"
        />
        <p v-if="sourceDescription" class="caption mb-2">
          <strong>{{ sourceName }}</strong> is described as
          &ldquo;{{ sourceDescription }}&rdquo;. That describes the original, so the copy needs
          its own.
        </p>
        <IngredientDescriptionField
          v-model="editDescription"
          :name="editName"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn text @click="cancel">Cancel</v-btn>
        <v-btn color="primary" :disabled="!canSave" @click="save">Clone</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import IngredientDescriptionField, {formatDescription} from '@/components/IngredientDescriptionField';

export default {
  name: 'CloneIngredientDialog',
  components: {IngredientDescriptionField},
  props: {
    value: {type: Boolean, required: true},
    // the ingredient being copied
    source: {type: Object, default: null}
  },
  data() {
    return {
      editName: '',
      editDescription: ''
    }
  },
  watch: {
    // the description starts empty on purpose: the original's belongs to a
    // different food, and leaving it in place is what made copies misleading
    value(showing) {
      if (showing) {
        this.editName = this.sourceName ? `${this.sourceName} CLONE` : '';
        this.editDescription = '';
      }
    }
  },
  computed: {
    sourceName() {
      return (this.source && this.source.fooddescriptionsimple) || '';
    },
    sourceDescription() {
      return (this.source && this.source.fooddescription) || '';
    },
    canSave() {
      return !!this.editName.trim() && !!formatDescription(this.editDescription);
    }
  },
  methods: {
    save() {
      if (!this.canSave) {
        return;
      }
      this.$emit('save', {
        fooddescriptionsimple: this.editName.trim(),
        fooddescription: formatDescription(this.editDescription)
      });
      this.$emit('input', false);
    },
    cancel() {
      this.$emit('input', false);
    }
  }
}
</script>
